export const environment = {/*
 production: true,
restBaseUrl: 'https://testservice.atb.bergamo.it/atb/rest/v2/permessituristici/',
restDownloadPdf: 'https://testservice.atb.bergamo.it/atb/',
restBaseRedirect: 'https://testservice.atb.bergamo.it/atb/#mdl=',
logoutPath: 'https://testservice.atb.bergamo.it/atb/rest/v2/logout',
uploadUrl: 'https://testservice.atb.bergamo.it/atb/rest/v2/UploadAllegatiPermessiTuristici?id=',
version: '1.3',
paymentUrl: 'https://coll-ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
*/

production: true,
  restBaseUrl: 'https://service.atb.bergamo.it/atb/rest/v2/',
  restBaseRedirect: 'https://service.atb.bergamo.it/atb/#mdl=',
  baseUrl: 'https://service.atb.bergamo.it/atb/',
  paymentUrl: 'https://ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
  version: '1.8.0',

  /*production: true,
  restBaseUrl: 'http://localhost:8080/atb/rest/v2/permessituristici/',
  restBaseRedirect: 'https://service.atb.bergamo.it/atb/#mdl=',
  restDownloadPdf: 'http://localhost:8080/atb/',
  logoutPath: 'http://localhost:8080/atb/rest/v2/logout',
  uploadUrl: 'http://localhost:8080/atb/rest/v2/UploadAllegatiPermessiTuristici?id=',
  version: '1.7.0',*/

  
  rows: 10
};






// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts